// extracted by mini-css-extract-plugin
export default {"Card":"Card_Card__pbvsb","CardGeneralText":"Card_CardGeneralText__IgSoL","CardTitle":"Card_CardTitle__TpuCo"};